module.exports = {
  "cookieName": "NethoneRef",
  "scriptId": "nethoneprofiler"
}